<template>
  <layout-auth>
    <v-form v-model="formulario" autocomplete="off">
      <v-container class="py-8">
        <v-row>
          <v-col>
            <h1 class="text-h4 font-weight-light py-5">{{ $t("Alertas.Alertas") }}</h1>
            <h2 class="text-h6 font-weight-light">Texto Descriptivo</h2>
          </v-col>
        </v-row>
        <v-row class="pb-5">
          <v-col sm="1" md="1" lg="1">
            <v-checkbox
              :color="entityConfig.primaryColor"
              v-model="form.isAlarmSms"
            >
              <template v-slot:label>
                <div class="" :style="`color: ${entityConfig.primaryColor}`">
                  SMS
                </div>
              </template>
            </v-checkbox>
          </v-col>
          <v-col sm="1" md="1" lg="1">
            <v-checkbox
              :color="entityConfig.primaryColor"
              v-model="form.isAlarmEmail"
            >
              <template v-slot:label>
                <div class="" :style="`color: ${entityConfig.primaryColor}`">
                  Email
                </div>
              </template>
            </v-checkbox>
          </v-col>
        </v-row>

        <v-row class="pb-5">
          <v-col sm="12" md="6" lg="3">
            <label>{{ $t("supplierData.phone") }}</label>
            <v-text-field
              :rules="[
                rules.min,
                rules.referenceValidatorHasNumber,
                rules.ValidatorHasPhone,
              ]"
              counter
              maxlength="9"
              hint="9 caracteres"
              :color="entityConfig.primaryColor"
              id="referencePhone"
              dense
              outlined
              :disabled="!form.isAlarmSms"
              v-model="form.phone"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="pb-5">
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-btn
              @click="postAlert"
              depressed
              :color="entityConfig.primaryColor"
              :style="`color: ${entityConfig.secondaryColor}`"
              class="float-end v-btn-width-default"
              :disabled="!formIsValid"
            >
              {{ $t("supplierData.save") }}
            </v-btn>
          </v-col>
          <v-col></v-col>
        </v-row>
      </v-container>
      <overlay :visible="spinner" :opacity="0.8"></overlay>
    </v-form>
  </layout-auth>
</template>

<script>
import LayoutAuth from "../../components/layouts/layout-auth.vue";
import Overlay from "../../components/layouts/overlay.vue";
import Api from "../../Services/index";
import passwordValidator from "password-validator";

export default {
  components: {
    "layout-auth": LayoutAuth,
    LayoutAuth,
    Overlay,
  },
  data() {
    return {
      form: {
        phone: "",
        isAlarmEmail: false,
        isAlarmSms: false,
      },
      userdata: {},
      spinner: false,
      entityConfig: {},
      formulario: false,
      userId: "",
      dataUser: [],
      Phone3: "",
      rules: {
        ValidatorHasPhone: (v) => {
          var schema = new passwordValidator();
          schema.has().digits(9);
          return schema.validate(v) || "Debe ser numérico";
        },
        min: (v) => v.length >= 9 || "9 caracteres minimo",
        referenceValidatorHasNumber: (v) => {
          var schema = new passwordValidator();
          schema.has().digits(1);
          return schema.validate(v) || "Debe ser numérico";
        },
      },
    };
  },

  mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;

    Api.defaults.headers.common["Authorization"] =
      "Bearer " + sessionStorage.getItem("authtoken");
    this.userdata = JSON.parse(sessionStorage.getItem("userData"));
    this.userId = this.userdata.id;
    this.getPhone();
  },

  computed: {
    formIsValid() {
      return this.formulario;
    },
  },
  methods: {
    async postAlert() {
      try {
        this.spinner = true;
        await Api.patch(`/usuarios/${this.userId}/alarmas`, this.form);
        this.spinner = false;
        this.$toast.success("Alerta Creada");
        this.$router.push("/alert");
      } catch (error) {
        this.$showError(this, error.response.data);
      } finally {
        this.spinner = false;
      }
    },

    async getPhone() {
      try {
        this.spinner = true;
        this.dataUser = await Api.get(`/usuarios/${this.userId}`);
        this.form.phone = this.dataUser.data.response.phone;

        this.form.isAlarmEmail = this.dataUser.data.response.isAlarmEmail;
        this.form.isAlarmSms = this.dataUser.data.response.isAlarmSms;

        this.spinner = false;
      } catch (error) {
        this.$showError(this, error.response.data);
      } finally {
        this.spinner = false;
      }
    },
  },
};
</script>
